import { ReactNode, useState } from "react";

export default function Accordion({ title, children }: { title: ReactNode; children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border rounded-lg mb-2 overflow-visible">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-200 dark:bg-her-darkSectionBg ${
          isOpen ? "rounded-t-lg" : "rounded-lg"
        }`}
      >
        <span className="text-left font-medium">{title}</span>
        <span>{isOpen ? "-" : "+"}</span>
      </button>
      {isOpen && <div className="border-t bg-white dark:bg-her-darkSectionBg overflow-visible last:rounded-b-lg">{children}</div>}
    </div>
  );
}
